import React, { useRef, useEffect } from "react";
import '../../styles/main.css';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from "@material-ui/core";

let globalOpenSnackbars = 0;

const useStyles = makeStyles({
  myAlert: {
    color: props => (props.severity === 'raw' ? '#333' : '#fff'),
    backgroundColor: props => {
      let rv = '';
      switch (props.severity) {
        case 'raw': rv = 'var(--ibs_color_snackbar_raw)'; break;
        case 'error': rv = 'var(--ibs_color_snackbar_error)'; break;
        case 'warning': rv = 'var(--ibs_color_snackbar_warning)'; break;
        case 'info': rv = 'var(--ibs_color_snackbar_info)'; break;
        case 'success': rv = 'var(--ibs_color_snackbar_success)'; break;
        default: rv = 'var(--ibs_color_snackbar_info)'; break;
      }
      return rv;
    },
  }
});

const CxSnackbar = props => {
  const { autoHideDuration } = props;
  const classes = useStyles(props);

  // 1. Referencia para controlar si el componente sigue montado
  const isMounted = useRef(true);

  const [open, setOpen] = React.useState(false);
  const [myValue, setMyValue] = React.useState(props.value);
  const [stackIndex, setStackIndex] = React.useState(0);

  // 2. Efecto para marcar el desmontaje
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  React.useImperativeHandle(props.xref, () => {
    return {
      getType,
      setVal,
      getVal,
      setOpen: setOpenSafe,
      setValAndOpen,
    };
  });

  const setOpenSafe = (newOpen) => {
    if (!isMounted.current) return; // Evita fugas si el padre llama al ref tarde

    if (newOpen === true) {
      globalOpenSnackbars += 1;
      setStackIndex(globalOpenSnackbars);
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const setVal = (newValue) => { 
    if (isMounted.current) setMyValue(newValue); 
  };

  const setValAndOpen = (newValue) => { 
    if (isMounted.current) {
      setMyValue(newValue); 
      setOpenSafe(true); 
    }
  };

  const getVal = () => { 
    return myValue; 
  };

  const getType = () => { 
    return 'CxSnackbar'; 
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);

    setTimeout(() => {
      globalOpenSnackbars = Math.max(globalOpenSnackbars - 1, 0);
      if (isMounted.current) {
        setStackIndex(0);
      }
    }, 100);

    if (props.onClose !== undefined) {
      props.onClose();
    }
  };

  const realOffsetIndex = Math.max(globalOpenSnackbars - stackIndex, 0);

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration === null ? null : (autoHideDuration || 2000)}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      style={{
        marginBottom: 20 + (realOffsetIndex * 70)
      }}
    >
      <Alert
        elevation={6}
        variant="filled"
        className={classes.myAlert}
        severity={props.severity === 'raw' ? 'info' : props.severity}
        icon={props.hideIcon ? false : undefined}
      >
        {myValue}
      </Alert>
    </Snackbar>
  );
};

export default CxSnackbar;